import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AccessGuard  {
  pages = JSON.parse(sessionStorage.getItem('pages'));

  constructor(
    private router: Router,
    private snackbar: MatSnackBar,
    private auth: AuthService
  ) {}

  canActivate(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let url: string = state.url.split('/').pop().split('=').pop();
    return this.checkAccess(url);
  }

  checkAccess(url: string): true | UrlTree {
    if (this.pages) {
      if (this.pages.includes(url)) {
        return true;
      } else {
        this.auth.logout();
        this.snackbar.open('Access denied', undefined, {
          duration: 5000,
          panelClass: 'mandatory',
        });
      }
    } else{
      this.snackbar.open('Please login to use the page', undefined, {
        duration: 5000,
        panelClass: 'mandatory',
      });
      this.auth.logout();
    }

    return this.router.parseUrl('/login');
  }
}
